import { Box, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";
import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
} from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { RegraReservaComponentProps } from "..";
import RangeSliderThumbLegend from "./RangeSliderThumbLegend";
import InputMoney from "ui/components/Input/InputMoney";

export default function PeriodoAntecendenciaReserva({
  control,
  watch,
  getNameLabel,
}: RegraReservaComponentProps) {
  const tipoIntervaloMinimoAntecendencia = watch(
    "tipoIntervaloMinimoAntecendencia"
  );
  const tipoIntervaloMaximoAntecendencia = watch(
    "tipoIntervaloMaximoAntecendencia"
  );
  const maximoAntecendencia = watch("maximoAntecendencia");
  const minimoAntedecendia = watch("minimoAntecendencia");

  const showSlider =
    (tipoIntervaloMinimoAntecendencia &&
      Number.isInteger(minimoAntedecendia)) ||
    (tipoIntervaloMaximoAntecendencia && Number.isInteger(maximoAntecendencia));

  const getSliderValue = () => {
    if (
      Number.isInteger(minimoAntedecendia) &&
      Number.isInteger(maximoAntecendencia)
    ) {
      return [0, 75, 100];
    } else if (Number.isInteger(minimoAntedecendia)) {
      return [75, 75, 100];
    } else if (Number.isInteger(maximoAntecendencia)) {
      return [0, 0, 100];
    }

    return [100, 100, 100];
  };

  return (
    <Box mb="48px">
      <Row gutter={32}>
        <Col sm={10}>
          <Text mb="16px">Período máximo de antecedência</Text>
          <Box as={Row} h="50px" gutter={32} overflow="visible">
            <Col sm={14}>
              <Field
                control={control}
                label="Formato de tempo"
                name="tipoIntervaloMaximoAntecendencia"
                render={({ field, isInvalid }) => (
                  <Box>
                    <SelectIntervaloPeriodo
                      value={field.value}
                      defaultValue={null}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      isInvalid={isInvalid}
                      getPopupContainer={() => document.body}
                    />
                  </Box>
                )}
              />
            </Col>

            {tipoIntervaloMaximoAntecendencia ? (
              <Col sm={10}>
                <Field
                  control={control}
                  label={getNameLabel(tipoIntervaloMaximoAntecendencia)}
                  rules={{
                    required: true,
                  }}
                  shouldUnregister
                  name="maximoAntecendencia"
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      isInvalid={isInvalid}
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="0"
                      step={1}
                      decimalScale={0}
                      decimalsLimit={0}
                    />
                  )}
                />
              </Col>
            ) : null}
          </Box>
        </Col>
        <Col sm={10}>
          <Text mb="16px">Período mínimo de antecedência</Text>
          <Row gutter={32}>
            <Col sm={14}>
              <Field
                control={control}
                label="Formato de tempo"
                name="tipoIntervaloMinimoAntecendencia"
                render={({ field, isInvalid }) => (
                  <SelectIntervaloPeriodo
                    value={field.value}
                    defaultValue={null}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    isInvalid={isInvalid}
                    getPopupContainer={() => document.body}
                  />
                )}
              />
            </Col>

            {tipoIntervaloMinimoAntecendencia ? (
              <Col sm={10}>
                <Field
                  control={control}
                  label={getNameLabel(tipoIntervaloMinimoAntecendencia)}
                  rules={{
                    required: true,
                  }}
                  name="minimoAntecendencia"
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      isInvalid={isInvalid}
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="0"
                      step={1}
                      decimalScale={0}
                      decimalsLimit={0}
                    />
                  )}
                />
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
      {showSlider ? (
        <Box mt={8}>
          <RangeSlider
            colorScheme="blue"
            cursor="default"
            pointerEvents="none"
            value={getSliderValue()}
          >
            <RangeSliderTrack bg={colors.primaryBlue40} h={1.5}>
              <RangeSliderFilledTrack />
            </RangeSliderTrack>
            <RangeSliderThumb
              index={0}
              opacity={
                Number.isFinite(maximoAntecendencia) &&
                tipoIntervaloMaximoAntecendencia
                  ? 1
                  : 0
              }
            >
              <RangeSliderThumbLegend
                align="left"
                text={`${maximoAntecendencia} ${getNameLabel(
                  tipoIntervaloMaximoAntecendencia
                )} máximo`}
              />
            </RangeSliderThumb>
            <RangeSliderThumb
              index={1}
              opacity={
                Number.isFinite(minimoAntedecendia) &&
                tipoIntervaloMinimoAntecendencia
                  ? 1
                  : 0
              }
            >
              <RangeSliderThumbLegend
                text={`${minimoAntedecendia} ${getNameLabel(
                  tipoIntervaloMinimoAntecendencia
                )} mínimo`}
              />
            </RangeSliderThumb>
            <RangeSliderThumb
              bg={colors.primary}
              w="6px"
              h="25px"
              rounded={0}
              index={2}
            >
              <Box fontWeight="medium" mt="65px" textAlign="right" mr={"56px"}>
                Dia da Reserva
              </Box>
            </RangeSliderThumb>
          </RangeSlider>
        </Box>
      ) : null}
    </Box>
  );
}
